<template>
	<v-row justify="center">
		<v-dialog v-if="dialog" v-model="dialog" persistent max-width="500" scrollable content-class="modal-schedule">
			<v-card>
				<v-card-title class="h6 pt-3 pb-3">Atur Jadwal Pengiriman {{code}}</v-card-title>
				<v-card-text class="pb-1">
					<v-alert v-model="message.show" dense dismissible type="error" elevation="1">
						{{message.text}}
					</v-alert>
					<v-col class="px-0 pt-0" v-show="schedules.length == 0">
						<div>Belum ada jadwal pengiriman</div>
					</v-col>
					<div>
						<v-form ref="formSchedule" role="form" v-on:submit.prevent="saveSchedule">
							<v-row v-for="(schedule, index) in schedules" :key="index">
								<v-col cols="6" sm="6" md="6" class="pb-0 pt-1">
									<v-menu v-model="schedule.showdate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="schedule.date | tanggalinput" placeholder="Tanggal Kirim" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :rules="[inputrules.required]" outlined dense small>
											</v-text-field>
										</template>
										<v-date-picker :min="today" :allowed-dates="allowedDates" color="primary" v-model="schedule.date" @input="schedule.showdate = false" locale="id"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="4" sm="4" md="4" class="pb-0 pt-1">
									<v-currency-field outlined dense :rules="[inputrules.required, inputrules.notnull]" v-model="schedule.quantity" placeholder="Jumlah"></v-currency-field>
								</v-col>
								<v-col cols="2" sm="2" md="2" class="pb-0 pt-0">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deleteSchedule(index)">
												<v-icon dark>mdi-delete</v-icon>
											</v-btn>
										</template>
										<span>Hapus</span>
									</v-tooltip>
								</v-col>
							</v-row>
						</v-form>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-btn height="35" light depressed color="primary" @click="addSchedule">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="saveSchedule">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	data () {
		return {
			dialog: false,
			schedules: [],
			maxQty: 0,
			index: '',
			message: {
				show: false,
				text: ''
			},
			code: '',
		}
	},
	components: {
	},
	computed: {
		totalQty() {
			let qty = 0
			this.schedules.forEach( (el) => {
				qty += parseInt(el.quantity)
			});
			return qty;
		},
		inDate() {
			return this.schedules.map( el => {
				if (el.date) {
					return el.date
				}
			});
		}
	},
	props: {
		value: Boolean,
		edit: String,
	},
	methods: {
		showModal (index, max, schedules, code) {
			this.message = {
				show: false,
				text: ''
			}
			this.schedules = [...schedules]
			this.maxQty = max
			this.index = index
			this.dialog = true
			this.code = code
		},
		allowedDates(val){
			return !this.inDate.includes(val)
		},
		hideModal (){
			this.dialog = false
		},
		deleteSchedule(index) {
			this.schedules.splice(index, 1)
		},
		addSchedule() {
			this.schedules.push({
				date: '',
				quantity: 0,
				showdate: false
			})
		},
		saveSchedule() {
			if (this.$refs.formSchedule.validate()) {
				if (this.totalQty == this.maxQty || this.totalQty == 0) {
					this.message = {
						show: false,
						text: ''
					}
					let schedules = this.schedules.map(el => {
						delete el.showdate
						return el
					})
					this.$emit('saveSchedule', schedules, this.index)
					this.hideModal()
				} else {
					this.message = {
						show: true,
						text: `Jumlah barang harus ${this.$options.filters.toNumber(this.maxQty)}`
					}
				}
			}
		}
	},
	watch: {
	},
}
</script>